import { Box, Flex, Text, Image } from "@chakra-ui/react";
import { useI18n } from "@/hooks/useI18n";
import { BXInput, BXButton } from "@/styles";
import { useMedia } from "@/hooks/useMedia";
import { useNavigate } from "react-router-dom";
import { fishCodeVaild } from "@/utils/regexp";
import { useState } from "react";
import ModalComponent from "@/components/ui/modal";
import {
  postUpdateUserInfoApi,
  getAccountValidationItemsApi,
} from "@/api/common";
import { postUpdateAntiPhishingCodeApi } from "@/api/anti";
import { useAppSelector } from "@/state/hooks";
import BXVerify from "@/components/ui/BXVerify";

const Update = () => {
  const { t } = useI18n();
  const { isMobile } = useMedia();
  const navigate = useNavigate();
  const [inputValue, setInputValue] = useState("");
  const [inputError, setInputError] = useState(false);
  const [isShow, setIsShow] = useState(false);
  const userInfo = useAppSelector((state) => state.user.userInfo);
  const [verifyModalShow, setVerifyModalShow] = useState(false);
  const [validationData, setValidationData] = useState({});
  const [validationType, setValidationType] = useState(""); // CLOSE UPDATE
  const [pageStatus, setPageStatus] = useState("INIT"); // INIT SUCCESS

  const vaildCode = () => {
    const ok = fishCodeVaild(inputValue);
    if (!ok) {
      setInputError(true);
      return;
    } else {
      setInputError(false);
      getAccountValidationItems();
    }
  };

  const getAccountValidationItems = async (type) => {
    const res = await getAccountValidationItemsApi({
      security_elem: "CUSTOM_IDENTIFIER", // CUSTOM_IDENTIFIER
      email: userInfo?.email || "",
      phone: userInfo?.phone || "",
      scene: "UPDATE",
    });
    if (res.code === 0) {
      setValidationData(res.data);
      setVerifyModalShow(true);
    }
  };

  const handleOk = async () => {
    const res = await postUpdateAntiPhishingCodeApi({
      custom_identifier: validationType === "CLOSE" ? "" : inputValue,
    });
    if (res.code === 0 && res?.data?.ok) {
      setIsShow(false);
      setVerifyModalShow(false);
      setPageStatus("SUCCESS");
    }
  };

  return (
    <>
      {pageStatus === "INIT" && (
        <Flex justifyContent={"center"} width={"100%"}>
          <Box width={isMobile ? "95%" : "500px"} mb={"60px"}>
            <Flex justifyContent={"space-between"} alignItems={"center"}>
              <Text
                color={"#010313"}
                fontSize={24}
                fontWeight={600}
                textAlign={"center"}
              >
                {t("fVZFezioYZUldZeom")}
              </Text>
              <Text
                fontSize={14}
                color={"rgba(208, 68, 87, 1)"}
                cursor={"pointer"}
                _hover={{
                  textDecoration: "underline",
                }}
                onClick={() => setIsShow(true)}
              >
                {t("QBVzRWgbGfOfpSuUhT")}
              </Text>
            </Flex>

            <Flex
              bgColor={"rgba(32, 26, 85, 0.05)"}
              fontSize={"12px"}
              color={"#010313"}
              alignItems={"center"}
              padding={"10px"}
              borderRadius={"12px"}
              mt={"10px"}
            >
              <Text fontSize={14} color={"rgba(1, 3, 19, 1)"}>
                {t("EDKGmHuEXhUgRraRiP")}
              </Text>
              <Text
                fontSize={24}
                color={"rgba(51, 59, 245, 1)"}
                fontWeight={600}
              >
                {userInfo?.custom_identifier}
              </Text>
            </Flex>

            <Text mt={"30px"} fontSize={"14px"}>
              {t("PjzEoOmNOYfZkOOETaN")}
            </Text>

            <BXInput
              placeholder={t("klnVEPRxuyJFMoFqJGEb")}
              fontSize={"12px"}
              _focus={{
                bgColor: "#EDEFFC",
              }}
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              className={inputError ? "error" : ""}
            />
            {inputError && (
              <Text color={"rgba(208, 68, 87, 1)"}>
                {t("gqDTaLpvoIRxJKWxbiS")}
              </Text>
            )}
            <Flex
              bgColor={"rgba(32, 26, 85, 0.05)"}
              fontSize={"12px"}
              color={"#010313"}
              alignItems={"center"}
              padding={"10px"}
              borderRadius={"12px"}
              mt={"10px"}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="25"
                viewBox="0 0 24 25"
                fill="none"
              >
                <path
                  d="M12.0013 4.03522C7.40963 4.03522 3.66797 7.77688 3.66797 12.3685C3.66797 16.9602 7.40963 20.7019 12.0013 20.7019C16.593 20.7019 20.3346 16.9602 20.3346 12.3685C20.3346 7.77688 16.593 4.03522 12.0013 4.03522ZM11.3763 9.03522C11.3763 8.69355 11.6596 8.41022 12.0013 8.41022C12.343 8.41022 12.6263 8.69355 12.6263 9.03522V13.2019C12.6263 13.5435 12.343 13.8269 12.0013 13.8269C11.6596 13.8269 11.3763 13.5435 11.3763 13.2019V9.03522ZM12.768 16.0185C12.7263 16.1269 12.668 16.2102 12.593 16.2935C12.5096 16.3685 12.418 16.4269 12.318 16.4685C12.218 16.5102 12.1096 16.5352 12.0013 16.5352C11.893 16.5352 11.7846 16.5102 11.6846 16.4685C11.5846 16.4269 11.493 16.3685 11.4096 16.2935C11.3346 16.2102 11.2763 16.1269 11.2346 16.0185C11.193 15.9185 11.168 15.8102 11.168 15.7019C11.168 15.5935 11.193 15.4852 11.2346 15.3852C11.2763 15.2852 11.3346 15.1935 11.4096 15.1102C11.493 15.0352 11.5846 14.9769 11.6846 14.9352C11.8846 14.8519 12.118 14.8519 12.318 14.9352C12.418 14.9769 12.5096 15.0352 12.593 15.1102C12.668 15.1935 12.7263 15.2852 12.768 15.3852C12.8096 15.4852 12.8346 15.5935 12.8346 15.7019C12.8346 15.8102 12.8096 15.9185 12.768 16.0185Z"
                  fill="#010313"
                />
              </svg>
              {t("GvVdEFzfUdBgWCGNCEK")}
            </Flex>
            <Flex
              mt={isMobile ? "20px" : "40px"}
              gap={"10px"}
              justifyContent={"center"}
            >
              <BXButton
                className="cancel"
                w={"20%"}
                onClick={() => {
                  navigate("/trade/accountManager?current=1");
                }}
              >
                {t("WbPTckCFMKtPHgAlL")}
              </BXButton>
              <BXButton
                w={"50%"}
                className={!inputValue ? "disabled" : ""}
                onClick={() => {
                  if (inputValue) {
                    vaildCode(inputValue);
                    setValidationType("UPDATE");
                  }
                }}
              >
                {t("YChcfaxDaLscdSPiRQz")}
              </BXButton>
            </Flex>
          </Box>
        </Flex>
      )}

      {pageStatus === "SUCCESS" && (
        <Flex flexDirection={"column"} alignItems={"center"}>
          <Image
            height={"40px"}
            width={"40px"}
            src="../../wwwsite/images/blue_success.svg"
          />
          <Text
            color={"#010313"}
            fontSize={"24px"}
            fontWeight={600}
            mt={"10px"}
          >
            {t("biXQrrlOVDoExCZZKC")}
          </Text>
          <BXButton
            className="cancel"
            mt={"50px"}
            onClick={() => {
              navigate("/trade/accountManager?current=1");
            }}
          >
            {t("FrzWGSiDSDzTfNgZH")}
          </BXButton>
        </Flex>
      )}
      <ModalComponent
        isShow={isShow}
        style={{ width: !isMobile ? "370px" : "calc(100% - 30px)" }}
      >
        <Flex
          flexDirection={"column"}
          alignItems={"flex-start"}
          p={["50px 30px"]}
          justifyContent={"center"}
        >
          <Text mt={"20px"} fontWeight={600} fontSize={"16px"}>
            {t("FbnUnoQURLgkjYRo")}
          </Text>
          <Text color={"#7B7C8F"} fontSize={"14px"} mt={"20px"}>
            {t("gCIMFQqwiFvyJwixUM")}
          </Text>
          <Flex justifyContent={"space-between"} mt={"30px"} w={"100%"}>
            <BXButton
              flex={"1"}
              className="cancel"
              onClick={() => {
                setIsShow(false);
              }}
            >
              {t("UNForxvjDLCZdGrmWkX")}
            </BXButton>
            <BXButton
              ml={"10px"}
              flex={"2.5"}
              onClick={() => {
                setValidationType("CLOSE");
                getAccountValidationItems("");
              }}
            >
              {t("AQrCocFqoKoYieUnT")}
            </BXButton>
          </Flex>
        </Flex>
      </ModalComponent>
      {verifyModalShow && (
        <BXVerify
          isShow={verifyModalShow}
          validationData={validationData}
          onClose={() => {
            setVerifyModalShow(false);
          }}
          onOk={() => {
            handleOk();
          }}
        />
      )}
    </>
  );
};

export default Update;
